/* src/app/modules/portal/components/feature-details/feature-details.component.scss */
#whatsNewModal {
  --sh-modal-body-wrapper-padding: 0;
  --sh-modal-wrapper-content-margin-bottom: 0;
}
#whatsNewAccessBar {
  --sh-access-bar-functions-slot-margin-left: 0;
}
.whatsNewContent {
  display: flex;
  height: calc(100% - 72px);
}
.whatsNewContent sh-pane {
  width: 30%;
  --sh-pane-wrapper-width: 100%;
  --sh-pane-wrapper-padding: 0;
}
.featureListHeader {
  padding-left: 0.5rem;
  width: calc(100% - 0.5rem);
}
.featureList {
  overflow: auto;
}
.featureDetail {
  width: 70%;
  display: flex;
  flex-direction: row;
  overflow: auto;
  background-color: rgba(var(--ui-1), var(--opacity-6));
}
.featuresForPcView {
  width: 100%;
  display: flow-root;
}
.featuresForPcView .loopPcImage {
  display: flex;
  justify-content: center;
}
.featuresForPcView img {
  max-width: calc(100% - 6rem);
}
.featuresForTabletView {
  height: 0%;
}
.featureContent {
  padding: 2rem 3rem;
  width: calc(100% - 6rem);
  word-wrap: break-word;
}
.image-loader {
  align-self: center;
  margin: auto;
}
.feature-loader {
  margin-top: 1rem;
}
.arrowRight {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 4px;
  top: 50%;
  background-color: white;
  border-radius: 50%;
}
.arrowLeft {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  left: 30%;
  top: 50%;
  background-color: white;
  border-radius: 50%;
  margin-left: 4px;
}
.carousel-col {
  width: 100%;
  display: flex;
  flex-direction: column;
}
[screen-tablet] :host-context .featureDetail,
[screen-phone] :host-context .featureDetail {
  width: 100%;
}
[screen-tablet] :host-context .whatsNewContent,
[screen-phone] :host-context .whatsNewContent {
  height: calc(100% - 56px);
}
[screen-tablet] :host-context .featuresForTabletView,
[screen-phone] :host-context .featuresForTabletView {
  height: 50%;
}
[screen-tablet] :host-context .featuresForTabletView .loopTabletImage,
[screen-phone] :host-context .featuresForTabletView .loopTabletImage {
  display: flex;
  justify-content: center;
}
[screen-tablet] :host-context .featuresForTabletView img,
[screen-phone] :host-context .featuresForTabletView img {
  max-width: 90%;
  max-height: calc(100% - 4rem);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
[screen-tablet] :host-context .featuresForPcView,
[screen-phone] :host-context .featuresForPcView {
  height: 0%;
}
[screen-tablet] :host-context .arrowLeft,
[screen-phone] :host-context .arrowLeft {
  left: 0;
}
/*# sourceMappingURL=feature-details.component.css.map */
